export const translations = {
  en: {
    // Common
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    import: 'Import',
    confirm: 'Confirm',
    close: 'Close',

    // Navigation
    dashboard: 'Dashboard',
    leads: 'Leads',
    messages: 'Messages',
    analytics: 'Analytics',
    settings: 'Settings',
    logout: 'Logout',

    // Auth
    login: 'Login',
    email: 'Email',
    password: 'Password',
    loginFailed: 'Login failed',

    // Leads
    lead: 'Lead',
    totalLeads: 'Total Leads',
    newLeads: 'New Leads',
    highValueLeads: 'High Value Leads',
    searchLeads: 'Search leads...',
    leadNotFound: 'Lead not found',
    allClassifications: 'All Classifications',
    allStatuses: 'All Statuses',
    leadsByStatus: 'Leads by Status',
    leadsByClassification: 'Leads by Classification',

    // Classifications
    classification: 'Classification',
    qualified: 'Qualified',
    potential: 'Potential',
    irrelevant: 'Irrelevant',

    // Status
    status: 'Status',
    detected: 'Detected',
    contacted: 'Contacted',
    engaged: 'Engaged',
    converted: 'Converted',
    archived: 'Archived',
    statusUpdated: 'Status updated successfully',
    errorUpdatingStatus: 'Error updating status',

    // Lead Details
    originalContent: 'Original Content',
    extractedInformation: 'Extracted Information',
    targetLocation: 'Target Location',
    intentType: 'Intent Type',
    stayDuration: 'Stay Duration',
    timeline: 'Timeline',
    budgetRange: 'Budget Range',
    contactInfo: 'Contact Information',
    confidenceScore: 'Confidence Score',
    source: 'Source',
    viewOriginal: 'View Original',
    phone: 'Phone',

    // Messages
    message: 'Message',
    messagesSent: 'Messages Sent',
    pendingApprovals: 'Pending Approvals',
    noMessagesAwaitingApproval: 'No messages awaiting approval',
    allMessagesReviewed: 'All messages have been reviewed',
    messagesSelected: 'messages selected',
    approveSelected: 'Approve Selected',
    selectAll: 'Select all',
    approve: 'Approve',
    reject: 'Reject',
    confirmReject: 'Confirm Reject',
    rejectionReason: 'Rejection reason...',
    messageApproved: 'Message approved successfully',
    messageRejected: 'Message rejected successfully',
    errorApprovingMessage: 'Error approving message',
    errorRejectingMessage: 'Error rejecting message',
    bulkApprovalComplete: 'Bulk approval complete',
    words: 'words',
    messageExceedsWordLimit: 'Warning: Message exceeds 150 word limit',

    // Message Types
    initial_outreach: 'Initial Outreach',
    follow_up: 'Follow Up',
    reminder: 'Reminder',
    final_attempt: 'Final Attempt',

    // Analytics
    responseRate: 'Response Rate',
    responseRatesByPlatform: 'Response Rates by Platform',
    conversions: 'Conversions',
    todaysActivity: "Today's Activity",
    responsesReceived: 'Responses Received',

    // Dates
    today: 'Today',
    newToday: 'new today',
    showing: 'Showing',
    to: 'to',
    of: 'of',
    results: 'results',
    page: 'Page',

    // Locations
    location: 'Location',
    confidence: 'confidence',

    // Platforms
    reddit: 'Reddit',
    facebook: 'Facebook',
    linkedin: 'LinkedIn',
    whatsapp: 'WhatsApp',

    // Intent Types
    long_stay: 'Long Stay',
    monthly_rental: 'Monthly Rental',
    relocation: 'Relocation',
    corporate_booking: 'Corporate Booking',
    family_accommodation: 'Family Accommodation',

    // Timelines
    urgent_2_weeks: 'Urgent (2 weeks)',
    within_1_month: 'Within 1 month',
    within_3_months: 'Within 3 months',
    flexible: 'Flexible',

    // Stay Durations
    '30-90_days': '30-90 days',
    '3-6_months': '3-6 months',
    '6-12_months': '6-12 months',
    '12_plus_months': '12+ months',

    // Errors
    errorLoadingLeads: 'Error loading leads',
    errorLoadingMessages: 'Error loading messages',
    errorLoadingAnalytics: 'Error loading analytics',
  },

  ar: {
    // Common
    loading: 'جاري التحميل...',
    error: 'خطأ',
    success: 'نجح',
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    view: 'عرض',
    search: 'بحث',
    filter: 'تصفية',
    export: 'تصدير',
    import: 'استيراد',
    confirm: 'تأكيد',
    close: 'إغلاق',

    // Navigation
    dashboard: 'لوحة التحكم',
    leads: 'العملاء المحتملون',
    messages: 'الرسائل',
    analytics: 'التحليلات',
    settings: 'الإعدادات',
    logout: 'تسجيل الخروج',

    // Auth
    login: 'تسجيل الدخول',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    loginFailed: 'فشل تسجيل الدخول',

    // Leads
    lead: 'عميل محتمل',
    totalLeads: 'إجمالي العملاء',
    newLeads: 'عملاء جدد',
    highValueLeads: 'عملاء ذوي قيمة عالية',
    searchLeads: 'البحث عن العملاء...',
    leadNotFound: 'العميل غير موجود',
    allClassifications: 'جميع التصنيفات',
    allStatuses: 'جميع الحالات',
    leadsByStatus: 'العملاء حسب الحالة',
    leadsByClassification: 'العملاء حسب التصنيف',

    // Classifications
    classification: 'التصنيف',
    qualified: 'مؤهل',
    potential: 'محتمل',
    irrelevant: 'غير ذي صلة',

    // Status
    status: 'الحالة',
    detected: 'تم الكشف',
    contacted: 'تم التواصل',
    engaged: 'متفاعل',
    converted: 'تم التحويل',
    archived: 'مؤرشف',
    statusUpdated: 'تم تحديث الحالة بنجاح',
    errorUpdatingStatus: 'خطأ في تحديث الحالة',

    // Lead Details
    originalContent: 'المحتوى الأصلي',
    extractedInformation: 'المعلومات المستخرجة',
    targetLocation: 'الموقع المستهدف',
    intentType: 'نوع النية',
    stayDuration: 'مدة الإقامة',
    timeline: 'الجدول الزمني',
    budgetRange: 'نطاق الميزانية',
    contactInfo: 'معلومات الاتصال',
    confidenceScore: 'درجة الثقة',
    source: 'المصدر',
    viewOriginal: 'عرض الأصل',
    phone: 'الهاتف',

    // Messages
    message: 'رسالة',
    messagesSent: 'الرسائل المرسلة',
    pendingApprovals: 'الموافقات المعلقة',
    noMessagesAwaitingApproval: 'لا توجد رسائل في انتظار الموافقة',
    allMessagesReviewed: 'تمت مراجعة جميع الرسائل',
    messagesSelected: 'رسائل محددة',
    approveSelected: 'الموافقة على المحدد',
    selectAll: 'تحديد الكل',
    approve: 'الموافقة',
    reject: 'رفض',
    confirmReject: 'تأكيد الرفض',
    rejectionReason: 'سبب الرفض...',
    messageApproved: 'تمت الموافقة على الرسالة بنجاح',
    messageRejected: 'تم رفض الرسالة بنجاح',
    errorApprovingMessage: 'خطأ في الموافقة على الرسالة',
    errorRejectingMessage: 'خطأ في رفض الرسالة',
    bulkApprovalComplete: 'اكتملت الموافقة الجماعية',
    words: 'كلمات',
    messageExceedsWordLimit: 'تحذير: الرسالة تتجاوز حد 150 كلمة',

    // Message Types
    initial_outreach: 'التواصل الأولي',
    follow_up: 'متابعة',
    reminder: 'تذكير',
    final_attempt: 'المحاولة الأخيرة',

    // Analytics
    responseRate: 'معدل الاستجابة',
    responseRatesByPlatform: 'معدلات الاستجابة حسب المنصة',
    conversions: 'التحويلات',
    todaysActivity: 'نشاط اليوم',
    responsesReceived: 'الردود المستلمة',

    // Dates
    today: 'اليوم',
    newToday: 'جديد اليوم',
    showing: 'عرض',
    to: 'إلى',
    of: 'من',
    results: 'نتائج',
    page: 'صفحة',

    // Locations
    location: 'الموقع',
    confidence: 'ثقة',

    // Platforms
    reddit: 'ريديت',
    facebook: 'فيسبوك',
    linkedin: 'لينكد إن',
    whatsapp: 'واتساب',

    // Intent Types
    long_stay: 'إقامة طويلة',
    monthly_rental: 'إيجار شهري',
    relocation: 'نقل',
    corporate_booking: 'حجز شركات',
    family_accommodation: 'سكن عائلي',

    // Timelines
    urgent_2_weeks: 'عاجل (أسبوعان)',
    within_1_month: 'خلال شهر',
    within_3_months: 'خلال 3 أشهر',
    flexible: 'مرن',

    // Stay Durations
    '30-90_days': '30-90 يوم',
    '3-6_months': '3-6 أشهر',
    '6-12_months': '6-12 شهر',
    '12_plus_months': '12+ شهر',

    // Errors
    errorLoadingLeads: 'خطأ في تحميل العملاء',
    errorLoadingMessages: 'خطأ في تحميل الرسائل',
    errorLoadingAnalytics: 'خطأ في تحميل التحليلات',
  },
};